import { HiOutlinePlus } from 'react-icons/hi';

export default function VariableCategory({ name, logo, onDelete }) {
  return (
    <div className="flex justify-between bg-white rounded-half py-2 px-3 gap-4">
      <div className="flex flex-row items-center space-x-2">
        {logo}
        <p>{name}</p>
      </div>
      <button type="button" onClick={onDelete}>
        <HiOutlinePlus className="rotate-45 text-2xl" />
      </button>
    </div>
  );
}
